import { Link } from "react-router-dom";

const Profile = () => (
    <div className="home-profile">
        <h1 className="home-profile-name">Carlos Hurtado</h1>
        
        <p id="home-profile-l1">
        Hello, I'm Carlos! 
        </p>

        <p id="home-profile-l1">
        I want to understand the world and solve complex problems. 
        </p>
        
        <p id="home-profile-l1">
        I'm interested in math, computer science, economics, philosophy, but also in technology, health, nature, and music.
        </p>

        <p id="home-profile-l1">
            I'm currently studying an MSc in Computer Science at EPFL.
        </p>

        <p id="home-profile-l1">
        You can find things I've worked on <Link to="/projects">here</Link>.
        </p>        

    </div>
)

const Group = (props) => {
    const isClickableTitle = (title) => {
        return title.toLowerCase() === "projects" || title.toLowerCase() === "writing";
    };

    return(
        <div className="row">
            <div className="column">
                {isClickableTitle(props.name) ? (
                    <Link to={`/${props.name.toLowerCase()}`} className="home-index-title">
                        <h2 className="home-index-title">{props.name.toUpperCase()}</h2>
                    </Link>
                ) : (
                    <h2 className="home-index-title">{props.name.toUpperCase()}</h2>
                )}
            </div>
            <div className="column">
                {props.pages.map((page) => (
                    <p className="index-links">
                        {page[2] === "_self" ? (
                            <Link
                                key={page[0]}
                                className="home-index-group-link"
                                to={page[1]}
                            >
                                {page[0]}
                            </Link>
                        ) : (
                            <a
                                key={page[0]}
                                className="home-index-group-link" 
                                href={page[1]} target={page[2]} rel={"noreferrer"}
                            >
                                {page[0]}
                            </a>
                        )
                        }
                    </p>
                ))}
            </div>
        </div>
    );
}

const Index = () => (
    <div className="home-index">
        <Group key={"self"} name={"carloshurtado.xyz"} pages={[
                                    ["Home","/", "_self"], 
                                    ["Projects","/projects", "_self"], 
                                    ["Writing","/writing", "_self"]
                                    ]}/>
        <Group key={"projects"} name={"projects"} pages={[
                                    ["Voice-controlled quadruped robots", "https://github.com/CarlOwOs/speech-to-ros", "_blank"],
                                    ["Sell online using AI with just a picture","https://github.com/CarlOwOs/SnapSell", "_blank"],
                                    ["RAG with attribution over massive datasets","https://github.com/CarlOwOs/parrandatathon2025", "_blank"], 
                                    ["ICML 2025 Workshop","https://openreview.net/pdf?id=6uTigj0bwJ", "_blank"],
                                    ]}/>
        <Group key={"web"} name={"web"} pages={[
                                    ["Github","https://github.com/CarlOwOs", "_blank"], 
                                    ["LinkedIn","https://www.linkedin.com/in/carloshuco/", "_blank"],
                                    //["Resume","/resume", "_self"],
                                    ["Scholar","https://scholar.google.com/citations?user=RA-2E_kAAAAJ&hl=en", "_blank"],
                                    ["X","https://x.com/CarlOwOs1", "_blank"], 
                                    ]}/>
        <Group key={"writing"} name={"writing"} pages={[
                                    ["On the invisibility of failure","/writing/failure", "_self"],
                                    ["Lessons From a Year at BCG","/writing/bcg", "_self"], 
                                    ]}/>
    </div>
)

const Home = () => (
    <div className="home-container">
        <Profile />
        <Index />
    </div>
);

export {Home};